import { Injectable } from '@angular/core';
import { SystemLanguage } from '@app/user';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SubtitlesService {
    constructor() {}
    private readonly choosenLangs = new BehaviorSubject<SystemLanguage[]>([]);
    private readonly validating = new BehaviorSubject<boolean>(false);
    readonly choosenLangs$ = this.choosenLangs.asObservable();
    readonly validating$ = this.validating.asObservable();

    setLangs(langs: SystemLanguage[]) {
        this.choosenLangs.next(langs);
    }

    setValidating(validating: boolean) {
        this.validating.next(validating);
    }
}
